export const emails = {
  address_one: `<div>rami.heinisuo (at)eduix (dot)com</div>`,
  address_two: `<div>sebulon (at) glowdom (dot)com</div>`,
  address_three: `<div>hnjohannes(at)nust (dot)na</div>`,
}
